import { render, staticRenderFns } from "./RecipientAddNew.vue?vue&type=template&id=f649b738"
import script from "./RecipientAddNew.vue?vue&type=script&lang=js"
export * from "./RecipientAddNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports